// Umami Analytics event helpers for Phaser game
// Usage: import { trackEvent } from './utils/ga-events';

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (import.meta.env.DEV) return;
  if (typeof window !== "undefined" && window.umami) {
    window.umami.track(eventName, params);
  }
}
